module.exports = __webpack_public_path__ + "img/loginBanner.0200a9af.jpg";